import { Injectable } from '@angular/core';


export interface TipoMensagem {
    danger: Boolean;
    info: Boolean;
} 

@Injectable()
export class MensagemService {

    private mensagem: string = undefined;

    private tipo_mensagem: TipoMensagem = {
        danger: false,
        info: false
    };

    constructor() { }

    getMensagem(): string {
        return this.mensagem;
    }

    getTipoMensagem(): TipoMensagem {
        return this.tipo_mensagem;
    }

    abrirMensagem(msg: string, tipo: string, tempo: number = 1) {
        this.mensagem = msg;
        this.tipo_mensagem.danger = tipo === "danger";
        this.tipo_mensagem.info = tipo === "info";
        setTimeout(() => {
            this.limparMensagem();
        }, (10000*tempo));
    }

    limparMensagem() {
        this.mensagem = undefined;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/mensagem.service.ts